import HistoriqueConfigs from '@/views/parametres/configs/historique-configs'
import $ from 'jquery'

export default {
    name: 'param-devise',
    components: {
        HistoriqueConfigs
    },
    props: {
        user_info: Object
    },
    data() {
        return {
            currency: {
                principal_currency: '',
                secondary_currency: '',
                rate: ''
            },
            is_loading: false,
            save_loading: false,
            can_edit: false,
            current_data: {
                principal_currency: '',
                secondary_currency: '',
                rate: ''
            },
            toggler: 0
        }
    },

    computed: {
        info_currency() {
            return this.$store.getters["info_currency"];
        },
    },

    mounted() {
        this.getDiversInfo()
    },

    methods: {
        async getDiversInfo() {
            this.is_loading = true

            this.$store.dispatch('getConfigInfoClinique', 'currency').then(() => {
                this.initFields()
            })
        },

        initFields() {
            const fld_keys = Object.keys(this.currency);
            fld_keys.forEach((key) => {
                this.currency[key] = this.info_currency[key]
                this.current_data[key] = this.info_currency[key]
                this.is_loading = false
            });
        },

        saveCurrency() {
            const isValid = this.$refs.currency_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true

            let form_data = new FormData();
            for (let key in this.currency) {
                form_data.append(key, this.currency[key])
            }
            form_data.append('data_type', 'currency')

            this.$store.dispatch('saveConfigInfoClinique', form_data).then((response) => {
                if (response > 0) {
                    this.successToast("Devise mise à jour avec succès")

                    let historique_data = {
                        current_data: this.current_data,
                        new_data: this.currency,
                        data_type: 'currency',
                        user_info: {
                            id: this.user_info.id,
                            user: this.user_info.name,
                            titre: this.user_info.titre
                        }
                    }

                    this.$store.dispatch('storeConfigHistorique', historique_data)
                }

                this.save_loading = false
            })
        },

        viewCurrencyHistorique() {
            this.toggler = (this.toggler == 1)?0:1

            $('.view-config-histo').modal('show')
        }
    }
}